import { render, staticRenderFns } from "./ColorDisplay.vue?vue&type=template&id=c8f982dc&scoped=true&"
import script from "./ColorDisplay.vue?vue&type=script&lang=js&"
export * from "./ColorDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ColorDisplay.vue?vue&type=style&index=0&id=c8f982dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f982dc",
  null
  
)

export default component.exports